import { computed } from '@vue/composition-api'
import store from '@/store'

export default (props, { root }) => {
  const route = root.$route
  const router = root.$router
  const me = computed(() => store.getters['auth/getUser'])
  const tab = computed(() => route.params.tab)

  const pushTab = newTab => {
    router.push({ name: 'organization-settings-account', params: { tab: newTab } })
  }

  return {
    me,
    tab,
    pushTab,
  }
}
